import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react/jsx-runtime';

import { Test } from '../../pages/ScheduleTestManagement';

const TestDetailsDialog = ({
  openTestDialog,
  setOpenTestDialog,
  selectedTest
}: {
  openTestDialog: boolean;
  setOpenTestDialog: (val: boolean) => void;
  selectedTest: Test;
}) => {
  return (
    <Transition appear show={openTestDialog} as={Fragment}>
      <Dialog as='div' className='relative z-50' onClose={setOpenTestDialog}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black/30' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel className='w-full max-w-md transform rounded-2xl bg-white p-6 align-middle shadow-xl transition-all'>
                <Dialog.Title className='text-lg font-medium'>
                  Test Details
                </Dialog.Title>

                {selectedTest && (
                  <div className='mt-4 space-y-3'>
                    <p>
                      <b>Test ID:</b> {selectedTest?.id}
                    </p>
                    <p>
                      <b>Name:</b> {selectedTest?.testName}
                    </p>
                    <p>
                      <b>Start:</b> {selectedTest?.testStartTime}
                    </p>
                    <p>
                      <b>End:</b> {selectedTest?.testEndTime}
                    </p>
                    <p>
                      <b>Status:</b> {selectedTest?.status}
                    </p>
                  </div>
                )}

                <button
                  className='mt-6 w-full rounded-md bg-blue-600 py-2 text-white'
                  onClick={() => setOpenTestDialog(false)}
                >
                  Close
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default TestDetailsDialog;
